import React from 'react';

import GroupDetailQuotaList  from 'components/Tvendo/Sale/QuotaBPartner/Colgate/GroupQuota/GroupQuotaDetail/List.js';

export default function () {
  return <GroupDetailQuotaList  />;
}